// extracted by mini-css-extract-plugin
export default {"header":"qY-z","logo":"rY-z","signin":"sY-z"};